document.addEventListener('DOMContentLoaded', function() {
    // Function to calculate the total height of all 'shopify-section' elements within a given parent element
    function calculateTotalHeight(parent) {
        let totalHeight = 0;
        parent.querySelectorAll('.shopify-section').forEach(section => {
            const computedStyle = window.getComputedStyle(section);
            const height = section.offsetHeight;
            const marginTop = parseFloat(computedStyle.marginTop);
            const marginBottom = parseFloat(computedStyle.marginBottom);
            totalHeight += height + marginTop + marginBottom + 100;
        });
        
        return totalHeight;
    }

    // Function to handle the click event on collapsible triggers
    function handleCollapsibleClick(event) {
        const trigger = event.currentTarget;

        // Check if the trigger does not have the class 'is-open'
        if (trigger.classList.contains('is-open')) {
            // Find the next sibling with the class 'collapsible-content'
            const content = trigger.nextElementSibling;
            if (content && content.classList.contains('collapsible-content')) {
                // Calculate the total height of 'shopify-section' elements within this collapsible-content
                let totalHeight = calculateTotalHeight(content);

                    if (content.querySelector('.has-wave-background')) {
                      totalHeight += 200; // Add extra 200px to the height
                  }
              
                // Update the collapsible-content CSS height property
                content.style.height = `${totalHeight}px`;
            }
        }
    }

    // Attach click event listeners to all collapsible triggers
    document.querySelectorAll('.accordion_section_group.collapsible-trigger').forEach(trigger => {
        trigger.addEventListener('click', handleCollapsibleClick);
    });

    
  
    function openAccordionFromURLHash() {
        const hash = window.location.hash;
        if (hash) {
            // Remove the '#' from the hash
            const id = hash.substring(1);
            const trigger = document.getElementById(id);
            if (trigger && trigger.classList.contains('collapsible-trigger')) {
                trigger.click();
            }
        }
    }

    // Trigger accordion open based on URL hash
    openAccordionFromURLHash();

  
  
});
